<template>
    <div style="width:100%;height:100%;background:#F4F4F4">
        <van-sticky>
            <NavBar :bgColor="'#1A3232'"/>
            <van-tabs @change="handleTabChange" v-model="active" title-inactive-color="rgba(255, 255, 255, 0.50)" title-active-color="#fff" color="#fff" background="rgb(26, 50, 50)" line-height="2px">
                <van-tab v-for="item in tabs" :title="item.label" :key="item.id" :name="item.id">
                </van-tab>
            </van-tabs>
        </van-sticky>
        <div class="orderData">
            <div v-for="item in orderData" :key="item.order_refund_id">
                <!-- All/In Progress/Completed 都显示状态标签 -->
                <RefundItem :rows="item" :showStatusTag="true" @refresh="handleItemRefresh"/>
            </div>
            <!-- 分页：All/In Progress/Completed 都展示 -->
            <div v-if="pageCount >= 1" class="paginationBox">
                <van-pagination
                    v-model="queryForm.page"
                    :page-count="pageCount"
                    mode="simple"
                    prev-text="Previous"
                    next-text="Next"
                    @change="handlePageChange"
                />
            </div>
        </div>
        <van-skeleton  title  :row="10" :loading="skeletonloading"></van-skeleton>
        <van-empty v-if="showEmpty" description="No data" />
    </div>
</template>
<script>
import NavBar from '@/components/NavBar/index.vue'
import RefundItem from '@/components/Order/refundItem.vue'
import { ensureUserLngLat } from '@/utils/location'
export default {
    name:'SalesOrderPage',
    created() {
        this.load()
    },
    data(){
        return {
            active: -1,
            loading: false,
            skeletonloading: false,
            showEmpty: false,
            tabs:[
                {id: -1, label: 'All'},
                {id: 0, label: 'In Progress'},
                // 后端售后状态：0=In Progress，20=Completed
                {id: 20, label: 'Completed'},
            ],
            orderData: [],
            totalItems: 0,
            pageCount: 1,
            queryForm:{
                page: 1,
                list_rows: 10,
                state: -1,
            }
        }
    },
    components:{
        NavBar,
        RefundItem
    },
    methods:{
        scrollToTop(){
            try {
                window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
            } catch (e) {
                document.documentElement.scrollTop = 0
                document.body.scrollTop = 0
            }
        },
        async load(){
            // Best-effort: fetch/cache user's lng/lat before requesting after-sale list.
            await ensureUserLngLat().catch(() => {})
            if(this.queryForm.page == 1){
                this.skeletonloading = true
            }
            this.showEmpty = false
            if (this.loading) {
                return
            }
            this.loading = true
            const params = { ...this.queryForm }
            const currentState = params.state
            try {
                const res = await this.$api.getServiceRefundList(params)
                this.skeletonloading = false
                this.loading = false
                if (currentState !== this.queryForm.state) {
                    return
                }
                if(res.code == 1){
                    const list = (res.data && res.data.list) ? res.data.list : {}
                    const data = (list && list.data) ? list.data : []
                    this.totalItems = Number(list.total || list.total_count || list.totalCount || list.count || 0)
                    this.pageCount =
                        Number(list.last_page || list.lastPage || list.page_count || list.pageCount || 0) ||
                        (this.totalItems ? Math.ceil(this.totalItems / this.queryForm.list_rows) : 0)
                    if (!this.pageCount || this.pageCount < 1) {
                        if (data.length === this.queryForm.list_rows) {
                            this.pageCount = this.queryForm.page + 1
                        } else {
                            this.pageCount = this.queryForm.page || 1
                        }
                    }
                    // 收集所有不重复的 shop_supplier_id
                    const supplierIds = [...new Set(data.map(item => item.shop_supplier_id).filter(id => id))]
                    // 批量获取商家详情
                    const supplierDetailsMap = {}
                    await Promise.all(supplierIds.map(async (supplierId) => {
                        try {
                            const detailRes = await this.$api.getSupplierDetail({ shop_supplier_id: supplierId })
                            if (detailRes.code == 1 && detailRes.data.detail) {
                                supplierDetailsMap[supplierId] = detailRes.data.detail
                            }
                        } catch (e) {
                            console.error('Failed to get merchant details:', e)
                        }
                    }))
                    // 将商家详情合并到售后数据中
                    const enrichedData = data.map(item => ({
                        ...item,
                        supplierDetail: supplierDetailsMap[item.shop_supplier_id] || null
                    }))
                    this.orderData = enrichedData
                    if(params.page == 1 && this.orderData.length == 0){
                        this.showEmpty = true
                    }
                }else{
                    this.pageCount = this.queryForm.page || 1
                }
            } catch (error) {
                console.error('Failed to load after-sales list:', error)
                this.skeletonloading = false
                this.loading = false
                this.pageCount = this.queryForm.page || 1
            }
        },
        handleTabChange(name){
            this.orderData = []
            this.loading = false
            this.queryForm.page = 1
            this.queryForm.state = name
            this.pageCount = 1
            this.totalItems = 0
            this.scrollToTop()
            this.load()
        },
        handlePageChange(page){
            this.queryForm.page = page
            this.scrollToTop()
            this.load()
        },
        handleItemRefresh(){
            // 平台介入申请成功后，刷新当前列表
            this.load()
        }
    }
}
</script>
<style lang="scss" scoped>
    .orderData{
        width: 100%;
        background: #F4F4F4;
        padding: 1rem;
        box-sizing: border-box;
    }
    .paginationBox{
        margin-top: 0.75rem;
        padding-bottom: 0.75rem;
    }
</style>
